if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const variantSelects = document.querySelector('variant-selects');
        const isSizeSelected = variantSelects
          ? !!variantSelects.querySelector(
              '.product-form__input--pill input:checked'
            ) ||
            !!variantSelects
              .querySelector('.dropdown-selected p')
              ?.getAttribute('selected')
          : true;

          if(!variantSelects.classList.contains('single-variant')) {
            // check size for different variants products only
            if (!isSizeSelected) {
              const sizeErrorMessage = document.querySelector(
                'variant-selects .size-error'
              );
              if (sizeErrorMessage) sizeErrorMessage.classList.add('error'); // add red error styling
              return;
            } else {
              const sizeErrorMessage = document.querySelector(
                'variant-selects .size-error'
              );
              if (sizeErrorMessage) sizeErrorMessage.classList.remove('error'); // revert to normal black text when valid
            }
          }


        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        let config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // Gift card wrapping handle 
        let giftCardElement = document.querySelector('[data-gift-wrapping]');
        config.body = formData;
        if(formData.get('product-type') == 'Gift Cards' && giftCardElement && giftCardElement.checked) {
          // console.log(formData.get('product-type'), giftCardElement, giftCardElement.checked);
          let items = [{
            id: formData.get('id'),
            quantity: formData.get('quantity'),
            properties:{
              _hasGiftWrapping: giftCardElement.dataset.giftWrapping
            }
          }];
          items.push({
            id: giftCardElement.dataset.giftWrapping,
            quantity: formData.get('quantity'),
            properties:{
              _isGiftWrapping: true
            }
          });
          let body = JSON.stringify({
            'sections': this.cart.getSectionsToRender().map((section) => section.id),
            'sections_url': window.location.pathname,
              items: items
          });
          config= { ...fetchConfig(), ...{ body } }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
